import {ComponentRef, Injectable, ViewContainerRef} from "@angular/core";
import {delay, Observable, Observer} from "rxjs";
import {FUIAlert, FUIAlertAction, FUIAlertActions, FUIAlertInput, FUIAlertType} from "./alert/alert.model";
import {FUIAlertComponent} from "./alert/alert.component";

@Injectable()
export class FUIAlertService {
    public placeholder: ViewContainerRef;

    public showConfirmationOkCancel(title: string, message: string, params: Object = {}, inputs: FUIAlertInput[] = []): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.CONFIRMATION,
            actions: [FUIAlertActions.CANCEL_ACTION, FUIAlertActions.OK_ACTION],
            inputs: inputs
        });
    }

    public showConfirmationYesNo(title: string, message: string, params: Object = {}, inputs: FUIAlertInput[] = []): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.CONFIRMATION,
            actions: [FUIAlertActions.NO_ACTION, FUIAlertActions.YES_ACTION],
            inputs: inputs
        });
    }

    public showConfirmationYesNoCancel(title: string, message: string, params: Object = {}, inputs: FUIAlertInput[] = []): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.CONFIRMATION,
            actions: [FUIAlertActions.CANCEL_ACTION, FUIAlertActions.NO_ACTION, FUIAlertActions.YES_ACTION],
            inputs: inputs
        });
    }

    public showError(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.ERROR,
            actions: [FUIAlertActions.OK_ACTION]
        });
    }

    public showErrorYesNo(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.ERROR,
            actions: [FUIAlertActions.NO_ACTION, FUIAlertActions.YES_ACTION]
        });
    }

    public showErrorOkCancel(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.ERROR,
            actions: [FUIAlertActions.CANCEL_ACTION, FUIAlertActions.OK_ACTION]
        });
    }

    public showWarning(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.WARNING,
            actions: [FUIAlertActions.OK_ACTION]
        });
    }

    public showWarningYesNo(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.WARNING,
            actions: [FUIAlertActions.NO_ACTION, FUIAlertActions.YES_ACTION]
        });
    }

    public showWarningOkCancel(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.WARNING,
            actions: [FUIAlertActions.CANCEL_ACTION, FUIAlertActions.OK_ACTION]
        });
    }

    public showSuccess(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.SUCCESS,
            actions: [FUIAlertActions.OK_ACTION]
        });
    }

    public showInformation(title: string, message: string, params: Object = {}): Observable<FUIAlertAction> {
        return this.show({
            title: title, message: message, params: params, type: FUIAlertType.INFORMATION,
            actions: [FUIAlertActions.OK_ACTION]
        });
    }

    public show(alert: FUIAlert, delayMs: number = 250): Observable<FUIAlertAction> {
        return new Observable<FUIAlertAction>((observer: Observer<any>) => {
            if (this.placeholder) {
                const componentRef: ComponentRef<FUIAlertComponent> = this.placeholder.createComponent(FUIAlertComponent);
                componentRef.instance.alert = alert;
                componentRef.instance.callback = observer;
                componentRef.instance.componentRef = componentRef;
            }
        }).pipe(delay(delayMs));
    }

    /**
     *
     * @param viewContainerRef
     */
    public setPlaceholder(viewContainerRef: ViewContainerRef) {
        this.placeholder = viewContainerRef;
    }
}
